<!--Main Content Area-->
<main aria-label="Main Content" class="pmd-content before-login-layout bg-primary">
    <div class="container-small container">
        <!-- Login Header -->
        <div class="row mb-4">
            <div class="col">
                <a class="navbar-brand" routerLink="/login" aria-label="PayKanz - Made Easy">
                    <img src="assets/images/kanz-logo-white.png" height="40" class="d-inline-block align-center"
                        alt="PayKanz - Made Easy">
                </a>
            </div>
            <div class="col-auto">
                <form class="language-dropdown-form">
                    <pmd-input-group-outline pmd-input-group-icon class="language-dropdown">
                        <pmd-input-group-text>
                            <i class="material-icons material-symbols-rounded md-light pmd-icon-sm">
                                language
                            </i>
                        </pmd-input-group-text>
                        <ng-select placeholder="Press Enter to select language"
                            ariaLabel="Press Enter to select language" appearance="outline" [searchable]="false"
                            pmdTextField [clearable]="false" labelForId="languageId" name="language"
                            [(ngModel)]="language" (change)="changeLang()"
                            class="pmd-select pmd-select-dark pmd-select-sm pmd-select-outline">
                            <ng-option *ngFor="let l of languages" [value]="l.id">{{l.name}}</ng-option>
                        </ng-select>
                    </pmd-input-group-outline>
                </form>
            </div>
        </div><!-- /END/ Login Header -->

        <!-- Login Sign Up Flow Card -->
        <pmd-card class="login-signup-card">
            <div class="row g-0">
                <div class="col-12 col-md-7 order-md-2 position-relative">
                    <!-- Content Area -->
                    <!-- <a href="javascript:void(0);" class="demo-link" id="showLoader" (click)="showLoader()">Show loader</a>
                    <a href="javascript:void(0);" class="demo-link d-none" id="hideLoader" (click)="hideLoader()">Hide loader</a> -->
                    <!-- Section Loader (Add "position-relative" class to wrapper div of section) -->
                    <div id="pageLoader" class="pmd-loader-card d-none" aria-label="Data is loading...">
                        <div class="loader">
                            <img src="assets/images/kanz-icon.png" class="fils-loader">
                            <svg class="circular" viewBox="25 25 50 50" aria-hidden="true">
                                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"
                                    aria-hidden="true" />
                            </svg>
                        </div>
                    </div>
                    <!-- /END/ Section Loader -->
                    <pmd-card-body class="login-signup-frm">
                        <router-outlet></router-outlet>
                    </pmd-card-body>
                </div>
                <div class="col-12 col-md-5 order-md-1">
                    <div pmd-card-image>
                        <owl-carousel-o [options]="introSliderOptions" #introSlider class="pmd-owl-carousel">
                            <!-- Slider 1 -->
                            <ng-template carouselSlide>
                                <div class="login-content-left text-center">
                                    <div class="mb-1">
                                        <img class="mb-4 img-fluid login-content-image mt-2" src="assets/images/create-invoices-graphic.png">
                                    </div>
                                    <h3 class="h4 mb-3">Create Invoices & Payment links</h3>
                                    <p>Offer your customers the best checkout experience with our digital payment solutions.</p>
                                </div>
                            </ng-template>
                            
                            <!-- Slider 2 -->
                            <ng-template carouselSlide>
                                <div class="login-content-left text-center">
                                    <div class="mb-1">
                                        <img class="mb-4 img-fluid login-content-image mt-2" src="assets/images/create-invoices-graphic.png">
                                    </div>
                                    <h3 class="h4 mb-3">Create Invoices & Payment links</h3>
                                    <p>Offer your customers the best checkout experience with our digital payment solutions.</p>
                                </div>
                            </ng-template>  

                            <!-- Slider 3 -->
                            <ng-template carouselSlide>
                                <div class="login-content-left text-center">
                                    <div class="mb-1">
                                        <img class="mb-4 img-fluid login-content-image mt-2" src="assets/images/create-invoices-graphic.png">
                                    </div>
                                    <h3 class="h4 mb-3">Create Invoices & Payment links</h3>
                                    <p>Offer your customers the best checkout experience with our digital payment solutions.</p>
                                </div>
                            </ng-template>  
                        </owl-carousel-o>
                    </div>
                </div>
            </div>
        </pmd-card><!-- /END/ Login Sign Up Flow Card -->
    </div>

    <!-- Login Footer -->
    <footer aria-label="Footer">
        <div class="container container-small">
            <app-footer class="login-app-footer"></app-footer>
        </div>
    </footer><!-- /END/ Login Footer -->
</main>
<!--/.Main Content Area-->